const state = {
  fullView: false,
  nav: [
    {
      header: 'Управление',
      items: [
        {
          name: 'Главная',
          route: { name: 'home' },
          icon: 'home'
        },
        {
          name: 'Управление',
          route: { name: 'admin' },
          icon: 'user-shield',
          collapsed: false,
          admin: true
        },
        {
          name: 'Мои заказы',
          route: { name: 'orders' },
          icon: 'cart-arrow-down'
        },
        {
          name: 'Мои клиенты',
          route: { name: 'clients' },
          icon: 'users'
        },
        {
          name: 'Мои настройки',
          route: { name: 'settings' },
          icon: 'cog',
          collapsed: false,
          submenu: [
            {
              name: 'Данные аккаунта',
              route: { name: 'account' },
              icon: 'user-circle'
            },
            {
              name: 'Платежи и баланс',
              route: { name: 'payments' },
              icon: 'money-bill-wave'
            }
          ]
        }
      ]
    },
    {
      header: 'Мои конструкторы',
      items: [
        {
          name: 'Конструктор',
          route: {
            name: 'constructors.constructor',
            params: { constructorId: 1 }
          },
          icon: 'cube',
          collapsed: false,
          submenu: [
            {
              name: 'Материалы и цены',
              route: {
                name: 'constructors.constructor.prices',
                params: { constructorId: 1 }
              },
              icon: 'money-bill-wave'
            },
            {
              name: 'Брендирование',
              route: {
                name: 'constructors.constructor.branding',
                params: { constructorId: 1 }
              },
              icon: 'paint-brush'
            },
            {
              name: 'Уведомления и письма',
              route: {
                name: 'constructors.constructor.notifications',
                params: { constructorId: 1 }
              },
              icon: 'envelope-open'
            },
            {
              name: 'Установить на сайт',
              route: {
                name: 'constructors.constructor.install',
                params: { constructorId: 1 }
              },
              icon: 'link'
            }
          ]
        }
      ]
    }
  ]
};

const getters = {
  navReady: ({ nav }) => {
    const navReady = [...nav];
    return navReady;
  }
};

const mutations = {
  expand: state => {
    state.fullView = true;
  },

  collapse: state => {
    state.fullView = false;
  }
};

export default {
  state,
  getters,
  mutations
};
